import {useField} from 'formik';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {useEffect} from 'react';
import SelectItem from '../../../../component/selectItem/SelectItem';
import * as css from './CategoryStep.css';
import store from '../../../../store';
import getSpecialTranslation from '../../../../functions/getSpecialTranslation';
import {sortByReferenceArray} from '../../../../library/sorts';
import useShow from '../../../../hooks/useShow';
import AddCategory from '../addCaregory/AddCategory';
import StepContext from '../stepContext/StepContext';
import StepRight from '../stepRight/StepRight';
import StepLeft from '../StepLeft/StepLeft';
import {getCategories} from '../../../../redux/categories/categoriesActions';
import {categoryIconList} from '../../../../constants/categoryIcons';

export const getTopCategory = (value, t) => {
    const categories = store.getState().categories?.eventCategories;
    const _t = (text) => t(`layout:${text}`);
    if(!value || !Array.isArray(value)) {
        value = [value];
    }
    return value.map(val => getSpecialTranslation(`category${val}`, _t) || categories.find(c => c.catId === val)?.title || '').join(', ');
};

function CategoryStep() {
    const {t} = useTranslation('newEvent');
    const tLayout = useTranslation('layout');
    const categories = useSelector((s) => s.categories.eventCategories);
    const pid = useSelector((s) => s.account.pid);
    const referenceCategories = [1,7,949,950,951,3,5,952,2,4,6,49,17,0];
    const categoriesList = sortByReferenceArray(categories||[], referenceCategories);
    const [categoryField, ,categoryHelpers] = useField('category');
    const editShow = useShow();

    useEffect(() => {
        if(!categories?.length) {
            getCategories();
        }
    }, [pid]);

    const handleSelected = (key) => {
        categoryHelpers.setTouched(true);
        const current = categoryField.value || [];
        if(!current.includes(key)) {
            categoryHelpers.setValue([...current, key]);
        }
    };
    return (
        <StepContext>
            {!editShow.isOpen && <> <StepRight name="category">
                <css.wrapper>
                    {categoriesList?.map((c,index)=>
                        <SelectItem key={c.catId}
                            catId={c.catId}
                            index={index}
                            text={getSpecialTranslation(`category${c.catId}`,tLayout.t)||c.title}
                            selectedArray={categoryField.value}
                            icon={categoryIconList[c.catId]||'packageImg'}
                            isEditable={!categoryIconList[c.catId]}
                            editShow={editShow}
                            onSelected={(key) => handleSelected(key)}
                        />)}
                    <css.addButton onClick={editShow.open} data-cy="new-event-add-category">
                        <css.icon />
                        <css.text>{t('addCategory')}</css.text>
                    </css.addButton>
                </css.wrapper>
            </StepRight>
            <StepLeft name="category"/></>}
            {editShow.isOpen && <AddCategory categoriesList={categoriesList} close={editShow.close} />}
        </StepContext>
    );
}

export default CategoryStep;